import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VehicleChargingFigureService {

  constructor(private readonly httpClient: HttpClient) { }
  
  getChargedEnergyTime(deviceSerialNumber: string[]):Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'charged-energy-time?batteryIdentifiers=' + deviceSerialNumber);
  }

  getSocDelta(deviceSerialNumber: string[]):Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'soc-difference-charging-session?batteryIdentifiers=' + deviceSerialNumber);
  }

  getStateOfCharge(deviceSerialNumber: string[]):Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'state-of-charge?batteryIdentifiers=' + deviceSerialNumber);
  }

}
